<div id="section">
    <div class="breadcrumb">
        <span class="breadcrumb-previous" (click)="goTo('home')">Home</span> >
        <span class="breadcrumb-previous" (click)="goTo('landing')">Gestione Prenotazioni</span> >
        <span class="breadcrumb-current">Prenotazione per conto terzi</span>
    </div>

    <div class="my-row">
        <mat-form-field class="my-form-field-color my-row-element-3" appearance="fill">
            <mat-label>Seleziona la nave</mat-label>
            <mat-select [(ngModel)]="selectedShip" name="shipSelect">
              @for (ship of availableShips; track ship.id_ship) {
                <mat-option [value]="ship">
                  {{ ship.ship_name }}
                </mat-option>
              }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="my-form-field-color my-row-element-3" style="margin-left: 10px">
            <mat-label>Numbero Cabina</mat-label>
            <input matInput #numeroCabina type="text" id="numeroCabina" name="numeroCabina" maxlength="100" />
        </mat-form-field>

        <div class="my-row-element-2" style="margin-bottom: 15px;">
            <button class="my-button confirm" mat-raised-button [disabled]="!numeroCabina.value || !selectedShip"
                (click)="search(numeroCabina.value)">Cerca</button>
        </div>
    </div>
    @if (firstSearch && (!listPassenger || listPassenger.length ==0)){
      Nessun passeggero trovato per la cabina inserita
    } @else if (listPassenger && listPassenger.length>0) {
        <div style="margin-top: 50px;">
          <div class="title-container">
            <h2>Seleziona un partecipante per il quale effettuare la prenotazione</h2>
          </div>

          <ng-container>
            <ul class="cards">
              @for (el of listPassenger; track el.uuid_passenger) {
                <li class="card" [ngClass]="el.selected ? 'selected' : 'selectable'" (click)="selectPassenger(el)">
                  <h3 class="card-title">{{ el.displayName }}</h3>
                </li>
              }

            </ul>
          </ng-container>

          <div class="btn-container">
            <button mat-raised-button class="my-button confirm" (click)="goTo('passenger')"
                    [disabled]="disabledButton">Procedi
            </button>
          </div>
        </div>

    }

</div>
